import { computed } from 'vue';
import { SearchCampaign } from '@studyportals/campaign-management-api-interface';
import datePresenter from '@/presenters/date-presenter';
import store from '@/store';

export default class SearchResultItemCode {
	private campaign: SearchCampaign;
	private onSelect: (campaign: SearchCampaign) => void;

	private campaignStartDate = computed((): Date => new Date(this.campaign.startDate));
	private campaignEndDate = computed((): Date => new Date(this.campaign.endDate));

	private destinationStartDate = computed((): Date | null => store.getters.startDate());
	private destinationEndDate = computed((): Date | null => store.getters.endDate());

	public formattedStartDate = computed((): string => {
		return datePresenter.transformDateObjectToUTCDateString(this.campaignStartDate.value, false);
	});

	public formattedEndDate = computed((): string => {
		return datePresenter.transformDateObjectToUTCDateString(this.campaignEndDate.value, false);
	});

	public isOverlapping = computed((): boolean => {
		if (!this.destinationStartDate.value || !this.destinationEndDate.value) {
			return false;
		}

		return datePresenter.doDateRangesOverlap(
			this.campaignStartDate.value,
			this.campaignEndDate.value,
			this.destinationStartDate.value,
			this.destinationEndDate.value
		);
	});

	constructor(campaign: SearchCampaign, onSelect: (campaign: SearchCampaign) => void) {
		this.campaign = campaign;
		this.onSelect = onSelect;
	}

	public handleSelect(): void {
		if (this.isOverlapping.value) {
			return;
		}

		this.onSelect(this.campaign);
	}
}
